"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeMarkers = exports.addMarkers = void 0;
const maplibre_gl_csp_js_1 = __importDefault(require("maplibre-gl/dist/maplibre-gl-csp.js"));
const makeAddress = (location) => {
    const { street1, street2, suite, city = '', state = '', zip = '' } = location;
    const streetAddress = [street1, street2, suite].filter(Boolean).join(', ');
    const stateAndZip = [state, zip].filter(Boolean).filter(Boolean).join(' ');
    return [streetAddress, city, stateAndZip].filter(Boolean).join(', ');
};
const createCustomMarkerElem = (content, location) => {
    const markerElem = document.createElement('span');
    markerElem.classList.add('marker');
    const address = makeAddress(location);
    markerElem.setAttribute('aria-label', `${content}. ${location.name}. ${address}`);
    const markerContentElem = document.createElement('b');
    markerContentElem.appendChild(document.createTextNode(content));
    markerElem.appendChild(markerContentElem);
    return markerElem;
};
const addMarkers = ({ locations, awsMapInstance, isStaticMap }) => {
    return locations
        .map((location, index) => {
        const { id, coordinates, popover, isSelected, isDisabled } = location;
        if (awsMapInstance && coordinates && id) {
            const markerElem = createCustomMarkerElem((index + 1).toString(), location);
            const marker = new maplibre_gl_csp_js_1.default.Marker({
                element: markerElem,
                opacity: isDisabled ? ' 0.5' : '1.0'
            })
                .setLngLat(coordinates)
                .addTo(awsMapInstance);
            const meta = {
                location,
                isSelected: Boolean(isSelected),
                isDisabled: Boolean(isDisabled)
            };
            if (isSelected) {
                marker.addClassName('selected');
            }
            if (isDisabled) {
                // not used for styling currently, but is used by tests
                marker.addClassName('disabled');
            }
            if (!isStaticMap && popover) {
                const popup = new maplibre_gl_csp_js_1.default.Popup({ offset: 25 }).setHTML(popover);
                marker.setPopup(popup);
            }
            return { marker, meta };
        }
        return null;
    })
        .filter(Boolean);
};
exports.addMarkers = addMarkers;
const removeMarkers = (markers) => {
    markers.forEach(({ marker }) => marker.remove());
};
exports.removeMarkers = removeMarkers;
//# sourceMappingURL=utils.js.map